import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-generatetable",
  "use": "icon-generatetable-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-generatetable\"><path d=\"M960.853 64.853H63.147C29.013 64.853 0 92.16 0 128v768c0 35.84 29.013 63.147 63.147 63.147h896c35.84 0 63.146-29.014 63.146-63.147V128c1.707-35.84-27.306-63.147-61.44-63.147zM319.147 896h-256V640h256v256zm0-319.147h-256v-256h256v256zM640 896H384V640h256v256zm0-319.147H384v-256h256v256zM960.853 896h-256V640h256v256zm0-319.147h-256v-256h256v256zm0 0\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol